(function() {
  // --- attachShadow intercept (must run first, before any third-party JS) ---
  // Klaviyo and other apps use closed shadow roots (mode:'closed'), which make
  // element.shadowRoot return null to all external scripts.  We wrap
  // Element.prototype.attachShadow so every shadow root -- open or closed --
  // is stored in a WeakMap.  getShadow() uses that map as a fallback so the
  // translator can see and translate popup content regardless of shadow mode.
  // This intercept is synchronous and runs before async third-party scripts.
  var _shadowRoots = new WeakMap();
  (function() {
    var _orig = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function(init) {
      var sr = _orig.call(this, init);
      _shadowRoots.set(this, sr);
      return sr;
    };
  })();
  function getShadow(el) {
    return el.shadowRoot || _shadowRoots.get(el) || null;
  }
  // --------------------------------------------------------------------------

  var STORE_ID = "d66a8a85-282b-457e-b59a-411bf6001b5c";
  var API_BASE = "https://shopify-omni-translator.replit.app";
  var SOURCE_LANG = "";
  var CONFIGURED_LANGS = [];
  var CACHE_REVISION = 61;
  var CACHE_TTL = 86400000; // 24 hours in ms
  var MAX_LS_ENTRIES = 500; // max translations stored per language in localStorage
  var cache = {}; // in-memory: "lang|text" -> translated string
  var lsCacheLoaded = {}; // tracks whether LS cache has been hydrated for a lang this session
  var EXCLUSIONS = []; // do-not-translate terms fetched from server at page load
  var GEO_LANG = null; // IP geo-language suggestion, resolved asynchronously during init
  var _widgetUpdate = null; // set by buildLangWidget; called on every language change

  function storageTryGet(type, key) {
    try { return (type === "local" ? localStorage : sessionStorage).getItem(key); } catch(e) { return null; }
  }
  function storageTrySet(type, key, val) {
    try { (type === "local" ? localStorage : sessionStorage).setItem(key, val); } catch(e) {}
  }
  function storageTryRemove(type, key) {
    try { (type === "local" ? localStorage : sessionStorage).removeItem(key); } catch(e) {}
  }

  function lsCacheKey(lang) {
    return "st_txc_" + STORE_ID + "_" + lang;
  }

  function loadLsCache(lang) {
    if (lsCacheLoaded[lang]) return;
    lsCacheLoaded[lang] = true;
    var raw = storageTryGet("local", lsCacheKey(lang));
    if (!raw) return;
    try {
      var entry = JSON.parse(raw);
      if (!entry || !entry.timestamp || !entry.translations) return;
      if (entry.revision !== CACHE_REVISION) {
        storageTryRemove("local", lsCacheKey(lang));
        return;
      }
      if (Date.now() - entry.timestamp >= CACHE_TTL) {
        storageTryRemove("local", lsCacheKey(lang));
        return;
      }
      var txns = entry.translations;
      for (var t in txns) {
        cache[lang + "|" + t] = txns[t];
      }
    } catch(e) {}
  }

  function saveLsCache(lang) {
    var txns = {};
    var prefix = lang + "|";
    for (var key in cache) {
      if (key.indexOf(prefix) === 0) {
        txns[key.slice(prefix.length)] = cache[key];
      }
    }
    // Cap to MAX_LS_ENTRIES most-recently iterated keys to avoid quota errors on large stores
    var allKeys = Object.keys(txns);
    if (allKeys.length > MAX_LS_ENTRIES) {
      var capped = {};
      for (var i = allKeys.length - MAX_LS_ENTRIES; i < allKeys.length; i++) {
        capped[allKeys[i]] = txns[allKeys[i]];
      }
      txns = capped;
    }
    function tryWrite(entries) {
      var payload = JSON.stringify({ timestamp: Date.now(), revision: CACHE_REVISION, translations: entries });
      try {
        localStorage.setItem(lsCacheKey(lang), payload);
      } catch(e) {
        var isQuota = e && (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED" || e.code === 22 || e.code === 1014);
        if (isQuota) {
          // Halve the entry count and retry once; if still failing, clear the key
          var halfKeys = Object.keys(entries);
          var half = Math.floor(halfKeys.length / 2);
          if (half > 0) {
            var trimmed = {};
            for (var j = halfKeys.length - half; j < halfKeys.length; j++) {
              trimmed[halfKeys[j]] = entries[halfKeys[j]];
            }
            try {
              localStorage.setItem(lsCacheKey(lang), JSON.stringify({ timestamp: Date.now(), revision: CACHE_REVISION, translations: trimmed }));
            } catch(e2) {
              storageTryRemove("local", lsCacheKey(lang));
            }
          } else {
            storageTryRemove("local", lsCacheKey(lang));
          }
        }
      }
    }
    try { tryWrite(txns); } catch(e) {}
  }

  function matchLang(code) {
    var c = code.toLowerCase();
    for (var i = 0; i < CONFIGURED_LANGS.length; i++) {
      if (CONFIGURED_LANGS[i].toLowerCase() === c) return CONFIGURED_LANGS[i];
    }
    var base = c.split("-")[0];
    for (var i = 0; i < CONFIGURED_LANGS.length; i++) {
      if (CONFIGURED_LANGS[i].toLowerCase() === base) return CONFIGURED_LANGS[i];
    }
    return null;
  }

  function detectUrlLocale() {
    var seg = window.location.pathname.replace(/^\//, "").split("/")[0] || "";
    return seg ? matchLang(seg) : null;
  }

  function detectBrowserLocale() {
    var prefs = (navigator.languages && navigator.languages.length) ? navigator.languages : (navigator.language ? [navigator.language] : []);
    for (var i = 0; i < prefs.length; i++) {
      var m = matchLang(prefs[i]);
      if (m) return m;
    }
    return null;
  }

  function stripLocalePrefix(path) {
    var segs = path.replace(/^\//, "").split("/");
    if (segs.length > 0 && matchLang(segs[0])) {
      segs.shift();
      return "/" + segs.join("/");
    }
    return path;
  }

  var currentLang = "";
  // inFlight[lang] = true while a translate fetch is pending — prevents concurrent requests.
  var inFlight = {};
  // backoffUntil[lang] = timestamp — skip translate calls until that time (after errors).
  var backoffUntil = {};
  // Timer handle for debouncing MutationObserver callbacks.
  var observerTimer = null;

  function getAllTextNodes(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        var p = node.parentNode;
        if (!p) return NodeFilter.FILTER_REJECT;
        var tag = p.tagName ? p.tagName.toLowerCase() : "";
        if (["script","style","noscript","meta","link"].includes(tag)) return NodeFilter.FILTER_REJECT;
        if (node.textContent.trim() === "") return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    // Walk into shadow roots (Task #143 open; Task #158 closed via getShadow).
    // TreeWalker cannot cross shadow boundaries, so we find elements with shadow
    // roots and recurse.  getShadow() checks el.shadowRoot (open) first, then
    // falls back to the _shadowRoots WeakMap populated by our attachShadow
    // intercept, covering closed shadow roots such as those used by Klaviyo.
    //
    // IMPORTANT: TreeWalker.nextNode() traverses only descendants, never the
    // root node itself.  We therefore call getShadow(root) explicitly first so
    // that when getAllTextNodes is called on a newly-injected element that is
    // itself a shadow host (common for web-component popup containers), we do
    // not miss the text nodes inside its shadow root.
    var rootSr = getShadow(root);
    if (rootSr) {
      var rootShadow = getAllTextNodes(rootSr);
      for (var ri = 0; ri < rootShadow.length; ri++) nodes.push(rootShadow[ri]);
    }
    var elemWalker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT);
    while (elemWalker.nextNode()) {
      var elSr = getShadow(elemWalker.currentNode);
      if (elSr) {
        var shadowNodes = getAllTextNodes(elSr);
        for (var si = 0; si < shadowNodes.length; si++) nodes.push(shadowNodes[si]);
      }
    }
    return nodes;
  }

  function getAllPlaceholderInputs(root) {
    // Returns all <input> and <textarea> elements within root that have a
    // non-empty placeholder attribute.  These elements expose their hint text
    // as an HTML attribute rather than a text node, so they are invisible to
    // getAllTextNodes and require a separate walk.
    //
    // Mirrors getAllTextNodes in structure: the root itself is checked first
    // (for cases where getAllPlaceholderInputs is called directly on an input
    // element), then its descendants are walked, and finally shadow roots are
    // recursed into via getShadow() so that placeholder fields inside
    // web-component popups (e.g. Klaviyo) are also translated.
    var inputs = [];
    if (root.nodeType === 1) {
      var rootTag = root.tagName ? root.tagName.toLowerCase() : "";
      if ((rootTag === "input" || rootTag === "textarea") &&
          root.getAttribute && root.getAttribute("placeholder") &&
          root.getAttribute("placeholder").trim() !== "") {
        inputs.push(root);
      }
    }
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
      acceptNode: function(el) {
        var tag = el.tagName ? el.tagName.toLowerCase() : "";
        if (tag === "input" || tag === "textarea") {
          var ph = el.getAttribute ? el.getAttribute("placeholder") : null;
          if (ph && ph.trim() !== "") return NodeFilter.FILTER_ACCEPT;
        }
        return NodeFilter.FILTER_SKIP;
      }
    });
    while (walker.nextNode()) inputs.push(walker.currentNode);
    // Walk shadow roots (same pattern as getAllTextNodes).
    var rootSr = getShadow(root);
    if (rootSr) {
      var rootShadow = getAllPlaceholderInputs(rootSr);
      for (var ri = 0; ri < rootShadow.length; ri++) inputs.push(rootShadow[ri]);
    }
    var elemWalker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT);
    while (elemWalker.nextNode()) {
      var elSr = getShadow(elemWalker.currentNode);
      if (elSr) {
        var shadowInputs = getAllPlaceholderInputs(elSr);
        for (var si = 0; si < shadowInputs.length; si++) inputs.push(shadowInputs[si]);
      }
    }
    return inputs;
  }

  function getTextContext(node, lookupText) {
    // Walk up through inline elements to find a containing phrase.  Used to
    // provide surrounding context for isolated single-word text nodes (like
    // "Mystery" or "Gift!" each in their own element) so the AI can translate
    // them correctly as part of the full phrase rather than in isolation.
    //
    // After landing on the first block ancestor, if its trimmed text is no
    // longer than the lookup text + 2 characters (the block adds no useful
    // surrounding context beyond the word itself), keep climbing through
    // further block ancestors — up to 3 levels — until one with substantially
    // broader text is found.  This covers the Klaviyo popup pattern where
    // "Mystery" and "Gift!" each live in their own <p> inside a shared <div>
    // whose textContent is "Mystery Gift!".  The climb cap prevents grabbing
    // the entire page body.
    var INLINE_TAGS = ["a","abbr","b","bdo","big","br","button","cite","code",
      "dfn","em","i","img","input","kbd","label","map","object","output","q",
      "samp","select","small","span","strong","sub","sup","textarea","time","tt","u","var"];
    var el = node.parentElement;
    if (!el) return "";
    while (el.parentElement && INLINE_TAGS.indexOf(el.tagName.toLowerCase()) >= 0) {
      el = el.parentElement;
    }
    // Block-ancestor climb: when the block we landed on adds no useful context
    // (text length is within 2 chars of the lookup), walk up to the next
    // parent block, up to 3 climbs.
    if (lookupText !== undefined) {
      var blockClimbs = 0;
      while (blockClimbs < 3 && el.parentElement) {
        var elText = el.textContent.trim().replace(/s+/g, " ");
        if (elText.length <= lookupText.length + 2) {
          el = el.parentElement;
          blockClimbs++;
        } else {
          break;
        }
      }
    }
    return el.textContent.trim().replace(/s+/g, " ");
  }

  function protectExclusions(text) {
    if (!EXCLUSIONS.length) return { prot: text, map: [] };
    var result = text;
    var map = [];
    for (var i = 0; i < EXCLUSIONS.length; i++) {
      var term = EXCLUSIONS[i];
      if (result.indexOf(term) >= 0) {
        var ph = "__EXCL" + map.length + "__";
        result = result.split(term).join(ph);
        map.push({ ph: ph, term: term });
      }
    }
    return { prot: result, map: map };
  }

  function restoreExclusions(text, map) {
    for (var i = 0; i < map.length; i++) {
      text = text.split(map[i].ph).join(map[i].term);
    }
    return text;
  }

  function translatePage(targetLang) {
    if (targetLang === SOURCE_LANG) return;
    if (backoffUntil[targetLang] && Date.now() < backoffUntil[targetLang]) return;
    if (inFlight[targetLang]) return;

    loadLsCache(targetLang);
    // Scan the full document, not just document.body.  Many Shopify app widgets
    // (floating launchers, gift popups, loyalty badges) inject their container
    // element as a direct child of <html> rather than inside <body>.  Using
    // document.documentElement as the root ensures those nodes are found on the
    // initial page scan.  The tag-based filter in getAllTextNodes already excludes
    // script/style/noscript/meta/link, so scanning the wider root is safe.
    var nodes = getAllTextNodes(document.documentElement);
    var texts = nodes.map(function(n) { return n.textContent.trim(); });
    // Build lookupTexts: for nodes we have already translated, use the stored
    // original source text as the cache key instead of the current textContent.
    // Without this, nodes showing translated text are sent back to the API as
    // untranslated source text, causing an English↔target-language bounce.
    var lookupTexts = nodes.map(function(n, i) {
      var orig = n._univtransOrig;
      // Parent-attribute fallback (Task #138): when Shopify replaces a text
      // node with a fresh one inside the same parent element, the new text
      // node has no _univtransOrig JS property (it lives on the old, detached
      // node).  However, the parent *element* retains its HTML attributes, so
      // data-univtrans-orig survives the text-node replacement.  If the JS
      // property is absent, attempt to recover orig from the parent attribute.
      var recoveredFromAttr = false;
      if (!orig && n.parentElement && n.parentElement.dataset.univtransOrig) {
        orig = n.parentElement.dataset.univtransOrig;
        recoveredFromAttr = true;
      }
      if (orig) {
        var cachedTx = cache[targetLang + "|" + orig];
        if (texts[i] === orig || texts[i] === cachedTx) {
          // Re-stamp the text node so future scans use the JS property
          // directly without needing the parent-attribute fallback.
          n._univtransOrig = orig;
          return orig;
        }
        // Suffix-tolerance guard (Task #136): Shopify's Markets JS sometimes
        // re-renders a translated node with 1–2 extra chars appended (e.g.
        // "Über uns" → "Über unss"). The standard check above misses this
        // because texts[i] matches neither orig nor cachedTx. Without this
        // branch the guard deletes _univtransOrig and the corrupted form
        // ("Über unss") is submitted to the server as apparent fresh source
        // text — which is the root cause of the residual "Über unss" entries.
        //
        // If texts[i] starts with cachedTx and the extra tail is ≤2 chars, we
        // know texts[i] is a Shopify-morphed variant of the known translation.
        // We pre-populate the cache so the variant is resolved in-memory on the
        // next scan, and return orig so the correct translation is applied to
        // the DOM without any API call.
        if (cachedTx && cachedTx.length >= 3 &&
            texts[i].length > cachedTx.length &&
            texts[i].length - cachedTx.length <= 2 &&
            texts[i].indexOf(cachedTx) === 0) {
          cache[targetLang + "|" + texts[i]] = cachedTx;
          n._univtransOrig = orig;
          return orig;
        }
        // No guard matched — text has genuinely changed. If we recovered orig
        // from the parent attribute, remove it so fresh text is translated
        // correctly and the attribute is re-stamped by applyTranslations.
        if (recoveredFromAttr && n.parentElement) {
          n.parentElement.removeAttribute('data-univtrans-orig');
        }
        delete n._univtransOrig;
      }
      return texts[i];
    });
    var originals = [];
    var protectedTexts = [];
    var maps = [];
    // contexts is parallel to originals: a surrounding-phrase hint for
    // short fragments (single-word, or ≤ 25 chars whose block has ≥ 2× more
    // text) so the AI can translate them correctly in context.  null = no hint.
    var contexts = [];
    for (var i = 0; i < lookupTexts.length; i++) {
      if (!cache[targetLang + "|" + lookupTexts[i]]) {
        // Not in cache — check exclusions, then queue for API.
        var isExactExclusion = false;
        for (var ex = 0; ex < EXCLUSIONS.length; ex++) {
          if (lookupTexts[i] === EXCLUSIONS[ex]) { isExactExclusion = true; break; }
        }
        if (isExactExclusion) {
          cache[targetLang + "|" + lookupTexts[i]] = lookupTexts[i];
          continue;
        }
        var r = protectExclusions(lookupTexts[i]);
        originals.push(lookupTexts[i]);
        protectedTexts.push(r.prot);
        maps.push(r.map);
        // Context hint: for single-word text nodes OR short multi-word fragments
        // (≤ 25 chars) whose parent block has substantially more text (≥ 2×),
        // assemble the surrounding phrase so the AI has enough context to
        // choose the right translation (e.g. "Gift!" in German means "poison"
        // without context, but in "Mystery Gift!" → "Geschenk!").
        // The context is truncated to 120 chars to keep prompt tokens bounded.
        var trimmedLookup = lookupTexts[i].trim();
        var isSingleWord = trimmedLookup.length > 0 && !/s/.test(trimmedLookup);
        var isShortFragment = trimmedLookup.length > 0 && trimmedLookup.length <= 25;
        if (isSingleWord || isShortFragment) {
          var ctx = getTextContext(nodes[i], trimmedLookup);
          if (ctx && ctx.length > 120) ctx = ctx.slice(0, 120);
          var ratioOk = ctx ? ctx.length >= 2 * trimmedLookup.length : false;
          var useCtx = ctx && ctx !== trimmedLookup && (isSingleWord || ratioOk);
          contexts.push(useCtx ? ctx : null);
        } else {
          contexts.push(null);
        }
      } else {
        // Cache hit — write the reverse identity mapping so that if the DOM node
        // loses _univtransOrig (e.g. Shopify re-renders it without our property),
        // the translated text is already in cache as its own identity and won't
        // be re-submitted to the API as apparent new source text.
        var cachedVal = cache[targetLang + "|" + lookupTexts[i]];
        if (cachedVal) cache[targetLang + "|" + cachedVal] = cachedVal;
      }
    }
    // --- Placeholder inputs (Task #163) -------------------------------------------
    // Collect <input> and <textarea> elements with non-empty placeholder attributes
    // and add uncached placeholder texts to the same originals batch so they are
    // translated in one API round-trip alongside text nodes.  Cached placeholder
    // texts are applied immediately by applyPlaceholderTranslations below.
    var pInputs = getAllPlaceholderInputs(document.documentElement);
    for (var pi = 0; pi < pInputs.length; pi++) {
      var pInp = pInputs[pi];
      var pOrig = pInp._univtransPlaceholderOrig ||
        (pInp.getAttribute("placeholder") || "").trim();
      if (!pOrig) continue;
      if (!cache[targetLang + "|" + pOrig]) {
        var pIsExcl = false;
        for (var pex = 0; pex < EXCLUSIONS.length; pex++) {
          if (pOrig === EXCLUSIONS[pex]) { pIsExcl = true; break; }
        }
        if (pIsExcl) { cache[targetLang + "|" + pOrig] = pOrig; continue; }
        var pR = protectExclusions(pOrig);
        originals.push(pOrig);
        protectedTexts.push(pR.prot);
        maps.push(pR.map);
        contexts.push(null); // no surrounding-phrase context for placeholder text
      } else {
        var pCachedVal = cache[targetLang + "|" + pOrig];
        if (pCachedVal) cache[targetLang + "|" + pCachedVal] = pCachedVal;
      }
    }
    applyTranslations(nodes, lookupTexts, targetLang);
    applyPlaceholderTranslations(pInputs, targetLang);
    if (originals.length === 0) return;
    // Cap the batch to prevent 413 errors on stores with many lazy-loaded nodes.
    var BATCH_TEXT_LIMIT = 100;
    var BATCH_CHAR_LIMIT = 50000;
    var batchEnd = originals.length;
    var totalChars = 0;
    for (var bi = 0; bi < originals.length; bi++) {
      totalChars += protectedTexts[bi].length;
      if (bi >= BATCH_TEXT_LIMIT || totalChars > BATCH_CHAR_LIMIT) {
        batchEnd = bi === 0 ? 1 : bi;
        break;
      }
    }
    var batchOriginals = batchEnd < originals.length ? originals.slice(0, batchEnd) : originals;
    var batchProtectedTexts = batchEnd < originals.length ? protectedTexts.slice(0, batchEnd) : protectedTexts;
    var batchMaps = batchEnd < originals.length ? maps.slice(0, batchEnd) : maps;
    var batchContexts = batchEnd < contexts.length ? contexts.slice(0, batchEnd) : contexts;
    inFlight[targetLang] = true;
    fetch(API_BASE + "/api/translations/translate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ storeId: STORE_ID, texts: batchProtectedTexts, targetLang: targetLang, sourceLang: SOURCE_LANG, contexts: batchContexts })
    }).then(function(res) {
      if (!res.ok) throw new Error("HTTP " + res.status);
      return res.json();
    }).then(function(data) {
      inFlight[targetLang] = false;
      delete backoffUntil[targetLang];
      for (var j = 0; j < batchOriginals.length; j++) {
        var tx = restoreExclusions(data.translations[j], batchMaps[j]);
        cache[targetLang + "|" + batchOriginals[j]] = tx;
        // Reverse identity mapping: if _univtransOrig is ever lost on a DOM node
        // (e.g. Shopify re-renders it), the translated text is already cached as
        // its own identity so it won't be re-submitted causing a back-translation.
        if (tx) {
          cache[targetLang + "|" + tx] = tx;
        }
      }
      saveLsCache(targetLang);
      translatePage(targetLang);
    }).catch(function(err) {
      inFlight[targetLang] = false;
      var prev = backoffUntil[targetLang] || 0;
      backoffUntil[targetLang] = Date.now() + (prev > Date.now() ? 60000 : 10000);
      console.warn("[ShopifyTranslator] Translation fetch failed:", err.message || err);
    });
  }

  function applyTranslations(nodes, texts, targetLang) {
    nodes.forEach(function(node, i) {
      var key = targetLang + "|" + texts[i];
      var translated = cache[key];
      if (!translated) return;
      // Identity response: the server returned the source text unchanged (e.g.
      // "Über uns" sent as English source after a node replacement, AI returns
      // "Über uns" via isAppendedTrailingS / isCorrupted guards).  There is
      // nothing to apply — the DOM is already showing the correct text.  Skipping
      // all writes here is important: stamping _univtransOrig and
      // data-univtrans-orig with the target-language text (not the English
      // original) would put those markers in a semantically wrong state and
      // restart the vicious cycle the moment the text node is next replaced.
      if (translated === texts[i]) return;
      // Remember the original (pre-translation) text on the node so that future
      // translatePage scans can use it as the cache key even after textContent has
      // been replaced with the translated string.  Without this, the MutationObserver
      // fires after each translation and the next scan finds the translated text,
      // misses the cache, sends it to the API, and receives a back-translation —
      // causing the visible English↔target-language bounce.
      node._univtransOrig = texts[i];
      // Stamp the parent element with a data attribute (Task #138) so that if
      // Shopify replaces this text node with a fresh one inside the same parent
      // element, the next scan can recover the original source text from the
      // attribute rather than treating the new node as untranslated source text.
      // Text nodes cannot hold HTML attributes; only Element nodes can — that
      // is why we set it on parentElement rather than on the text node itself.
      if (node.parentElement) {
        node.parentElement.setAttribute('data-univtrans-orig', texts[i]);
      }
      // Preserve the leading/trailing whitespace that surrounds the translatable
      // content in this text node.  Shopify themes often place spaces around inline
      // elements like <strong> in separate text nodes (e.g. "word " before <strong>
      // and " text" after </strong>).  Without this, those spaces are silently
      // dropped because the cache key is the trimmed string and the cached value
      // carries no surrounding whitespace.
      var raw = node.textContent;
      var leadingWs  = raw.match(/^s*/)[0];
      var trailingWs = raw.match(/s*$/)[0];
      var withSpaces = leadingWs + translated + trailingWs;
      // Only write if the text actually changes — setting the same value still fires
      // the MutationObserver, which would create a continuous 500ms polling loop.
      if (raw !== withSpaces) node.textContent = withSpaces;
    });
  }

  function applyPlaceholderTranslations(inputs, targetLang) {
    // Applies cached placeholder translations to <input> and <textarea> elements.
    // Parallel to applyTranslations but writes to the placeholder attribute
    // rather than textContent.  _univtransPlaceholderOrig stores the original
    // English placeholder so that future scans use it as the cache key even
    // after setAttribute has replaced it with the translated string.
    for (var pi = 0; pi < inputs.length; pi++) {
      var inp = inputs[pi];
      var orig = inp._univtransPlaceholderOrig ||
        (inp.getAttribute ? inp.getAttribute("placeholder") || "" : "");
      orig = orig.trim();
      if (!orig) continue;
      var translated = cache[targetLang + "|" + orig];
      if (!translated) continue;
      if (translated === orig) continue; // identity — nothing to write
      if (!inp._univtransPlaceholderOrig) inp._univtransPlaceholderOrig = orig;
      var current = inp.getAttribute ? inp.getAttribute("placeholder") : "";
      if (current !== translated) inp.setAttribute("placeholder", translated);
    }
  }

  // Begins observing any shadow roots found within the given root element that
  // have not yet been tracked.  Must be called after domObserver is initialised.
  // Shadow-DOM mutations are invisible to the document-level MutationObserver;
  // without this, popup content injected asynchronously into a web-component
  // shadow root is never seen by the translator.
  function observeNewShadowRoots(root, depth) {
    if (!domObserver) return;
    if ((depth || 0) >= 10) return; // guard against pathological deeply-nested shadow roots
    var rootSr = getShadow(root);
    if (rootSr && !rootSr._univtransObserved) {
      domObserver.observe(rootSr, { childList: true, subtree: true, characterData: true });
      rootSr._univtransObserved = true;
      observeNewShadowRoots(rootSr, (depth || 0) + 1);
    }
    var srWalker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT);
    while (srWalker.nextNode()) {
      var sr = getShadow(srWalker.currentNode);
      if (sr && !sr._univtransObserved) {
        domObserver.observe(sr, { childList: true, subtree: true, characterData: true });
        sr._univtransObserved = true;
        observeNewShadowRoots(sr, (depth || 0) + 1);
      }
    }
  }

  var domObserver = null;
  function observeDOMChanges() {
    if (domObserver) return;
    domObserver = new MutationObserver(function(mutations) {
      if (!currentLang || currentLang === SOURCE_LANG) return;
      // Immediately apply cached translations to any nodes added by this mutation
      // batch (Task #143).  This eliminates the visible flash of untranslated
      // content for texts already in the in-memory cache (e.g. popup text from a
      // previous page load).  Only childList mutations carry addedNodes; characterData
      // mutations (in-place text changes) are handled by the debounced full-page
      // scan below.
      var immediateNodes = [];
      var immPInputs = []; // Task #163: placeholder inputs from newly-added elements
      for (var mi = 0; mi < mutations.length; mi++) {
        var mutation = mutations[mi];
        if (mutation.type === "childList") {
          for (var ni = 0; ni < mutation.addedNodes.length; ni++) {
            var added = mutation.addedNodes[ni];
            if (added.nodeType === 3) {
              // Text node injected directly.
              immediateNodes.push(added);
            } else if (added.nodeType === 1) {
              // Element node — collect all text nodes inside it, including any
              // that live inside open shadow roots (getAllTextNodes recurses into them).
              var childTextNodes = getAllTextNodes(added);
              for (var ci = 0; ci < childTextNodes.length; ci++) {
                immediateNodes.push(childTextNodes[ci]);
              }
              // Also collect placeholder inputs from the new subtree (Task #163).
              var addedPInputs = getAllPlaceholderInputs(added);
              for (var api = 0; api < addedPInputs.length; api++) immPInputs.push(addedPInputs[api]);
              // Begin observing any shadow roots found inside the new element so
              // that content injected asynchronously into those shadows (e.g. a
              // popup dialog appearing after a click) fires our observer.
              observeNewShadowRoots(added);
            }
          }
        }
      }
      // Immediately apply cached placeholder translations for newly-added inputs (Task #163).
      if (immPInputs.length > 0) applyPlaceholderTranslations(immPInputs, currentLang);
      if (immediateNodes.length > 0) {
        var immTexts = immediateNodes.map(function(n) { return n.textContent.trim(); });
        applyTranslations(immediateNodes, immTexts, currentLang);
        // If any newly-added text nodes are not yet in the translation cache,
        // trigger translatePage immediately rather than waiting for the 500ms
        // debounce.  Popup widgets often continuously mutate the DOM (cursor
        // blinks, input tracking, etc.), which would reset the debounce timer
        // indefinitely so the API call for uncached popup text never fires.
        var hasUncached = false;
        for (var iu = 0; iu < immTexts.length; iu++) {
          if (immTexts[iu] && !cache[currentLang + "|" + immTexts[iu]]) {
            hasUncached = true;
            break;
          }
        }
        // Also check for uncached placeholder texts (Task #163).
        if (!hasUncached) {
          for (var ip = 0; ip < immPInputs.length; ip++) {
            var iPh = immPInputs[ip]._univtransPlaceholderOrig ||
              (immPInputs[ip].getAttribute("placeholder") || "").trim();
            if (iPh && !cache[currentLang + "|" + iPh]) { hasUncached = true; break; }
          }
        }
        if (hasUncached) {
          if (observerTimer) clearTimeout(observerTimer);
          if (!inFlight[currentLang]) {
            translatePage(currentLang);
          }
          // If inFlight: the recursive translatePage call at the end of the
          // API response handler will pick up the newly-visible popup content.
          return;
        }
      } else if (immPInputs.length > 0) {
        // No text nodes added, but placeholder inputs arrived — check if any
        // are uncached and trigger translatePage if so (Task #163).
        for (var ip2 = 0; ip2 < immPInputs.length; ip2++) {
          var iPh2 = immPInputs[ip2]._univtransPlaceholderOrig ||
            (immPInputs[ip2].getAttribute("placeholder") || "").trim();
          if (iPh2 && !cache[currentLang + "|" + iPh2]) {
            if (observerTimer) clearTimeout(observerTimer);
            if (!inFlight[currentLang]) translatePage(currentLang);
            return;
          }
        }
      }
      // Debounce: wait 500 ms after the last mutation before the full translatePage
      // scan, which handles uncached texts (fetches from the API) and any content
      // not covered by the immediate pass above (e.g. characterData-only changes).
      if (observerTimer) clearTimeout(observerTimer);
      observerTimer = setTimeout(function() { translatePage(currentLang); }, 500);
    });
    // characterData: true catches in-place text mutations on existing nodes —
    // e.g. a third-party app that updates textContent without replacing the element.
    // Observe document.documentElement (not document.body) so that widgets
    // appended directly to <html> — outside <body> — also trigger the scan.
    domObserver.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    // Also observe shadow roots already present in the DOM at init time so that
    // future mutations inside them are caught without waiting for another element
    // to be added to the main document tree.
    observeNewShadowRoots(document.documentElement);
  }

  function applyLang(lang) {
    if (!lang || lang === currentLang) return;
    // If we are currently on a Shopify locale URL (e.g. /de/products), the page
    // was rendered natively by Shopify — in-place translation cannot change its
    // language.  Navigate to the equivalent path for the new locale instead, the
    // same way the init code gets visitors to a locale URL in the first place.
    var currentUrlLocale = detectUrlLocale();
    if (currentUrlLocale && lang !== currentUrlLocale) {
      var stripped = stripLocalePrefix(window.location.pathname) || "/";
      var newPath = (lang === SOURCE_LANG)
        ? stripped
        : "/" + lang + (stripped === "/" ? "" : stripped);
      storageTrySet("local", "st_lang", lang);
      window.location.href = newPath + window.location.search + window.location.hash;
      return;
    }
    // On a non-locale URL the page was translated in-place by JS.  Reverting
    // to the source language means restoring original DOM text, which is easiest
    // achieved by reloading the page (Shopify serves it in the source language).
    // Save the preference first so init does not auto-redirect on the reload.
    if (lang === SOURCE_LANG) {
      storageTrySet("local", "st_lang", SOURCE_LANG);
      window.location.replace(window.location.pathname + window.location.search + window.location.hash);
      return;
    }
    currentLang = lang;
    storageTrySet("local", "st_lang", lang);
    loadLsCache(lang);
    evictExclusionsFromCache(lang);
    translatePage(lang);
    if (_widgetUpdate) _widgetUpdate(lang);
  }

  function onUrlChange() {
    var urlLocale = detectUrlLocale();
    if (urlLocale && urlLocale !== currentLang) applyLang(urlLocale);
  }

  (function patchHistory() {
    var orig = history.pushState;
    history.pushState = function() {
      orig.apply(history, arguments);
      onUrlChange();
    };
    window.addEventListener("popstate", onUrlChange);
  })();

  window.ShopifyTranslator = {
    setLanguage: function(lang) {
      currentLang = lang;
      storageTrySet("local", "st_lang", lang);
      translatePage(lang);
      if (_widgetUpdate) _widgetUpdate(lang);
    },
    getCurrentLanguage: function() { return currentLang; },
    resetLocale: function() {
      storageTryRemove("local", "st_lang");
      storageTryRemove("session", "st_redirected");
      var cleaned = stripLocalePrefix(window.location.pathname);
      window.location.replace(cleaned + window.location.search + window.location.hash);
    }
  };

  function evictExclusionsFromCache(lang) {
    if (!EXCLUSIONS.length) return;
    var prefix = lang + "|";
    var keysToDelete = [];
    for (var key in cache) {
      if (!Object.prototype.hasOwnProperty.call(cache, key)) continue;
      if (key.indexOf(prefix) !== 0) continue;
      var originalText = key.slice(prefix.length);
      for (var i = 0; i < EXCLUSIONS.length; i++) {
        if (originalText.indexOf(EXCLUSIONS[i]) >= 0) {
          keysToDelete.push(key);
          break;
        }
      }
    }
    for (var k = 0; k < keysToDelete.length; k++) {
      delete cache[keysToDelete[k]];
    }
    if (keysToDelete.length) {
      saveLsCache(lang);
    }
  }

  // ---------------------------------------------------------------------------
  // Language picker widget
  // Merchants place <div id="univtrans-lang-picker"></div> anywhere in their
  // theme (typically the header).  buildLangWidget() finds it after the config
  // loads, renders a flag+code button with a scrollable dropdown, and keeps the
  // display in sync via _widgetUpdate whenever applyLang / setLanguage is called.
  // ---------------------------------------------------------------------------

  // lang code → ISO 3166-1 alpha-2 country code used for the flag emoji
  var _LANG_CC = {
    "af":"ZA","ar":"SA","az":"AZ","be":"BY","bg":"BG","bn":"BD","bs":"BA",
    "ca":"ES","cs":"CZ","cy":"GB","da":"DK","de":"DE","el":"GR","en":"US",
    "es":"ES","et":"EE","eu":"ES","fa":"IR","fi":"FI","fr":"FR","ga":"IE",
    "gl":"ES","gu":"IN","he":"IL","hi":"IN","hr":"HR","hu":"HU","hy":"AM",
    "id":"ID","is":"IS","it":"IT","ja":"JP","ka":"GE","kk":"KZ","km":"KH",
    "kn":"IN","ko":"KR","lt":"LT","lv":"LV","mk":"MK","ml":"IN","mn":"MN",
    "mr":"IN","ms":"MY","mt":"MT","nb":"NO","nl":"NL","pa":"IN","pl":"PL",
    "pt":"PT","ro":"RO","ru":"RU","sk":"SK","sl":"SI","sq":"AL","sr":"RS",
    "sv":"SE","sw":"KE","ta":"IN","te":"IN","th":"TH","tl":"PH","tr":"TR",
    "uk":"UA","ur":"PK","uz":"UZ","vi":"VN","zh":"CN","zh-TW":"TW"
  };

  var _LANG_NAME = {
    "af":"Afrikaans","ar":"Arabic","az":"Azerbaijani","be":"Belarusian",
    "bg":"Bulgarian","bn":"Bengali","bs":"Bosnian","ca":"Catalan","cs":"Czech",
    "cy":"Welsh","da":"Danish","de":"German","el":"Greek","en":"English",
    "es":"Spanish","et":"Estonian","eu":"Basque","fa":"Persian","fi":"Finnish",
    "fr":"French","ga":"Irish","gl":"Galician","gu":"Gujarati","he":"Hebrew",
    "hi":"Hindi","hr":"Croatian","hu":"Hungarian","hy":"Armenian",
    "id":"Indonesian","is":"Icelandic","it":"Italian","ja":"Japanese",
    "ka":"Georgian","kk":"Kazakh","km":"Khmer","kn":"Kannada","ko":"Korean",
    "lt":"Lithuanian","lv":"Latvian","mk":"Macedonian","ml":"Malayalam",
    "mn":"Mongolian","mr":"Marathi","ms":"Malay","mt":"Maltese",
    "nb":"Norwegian","nl":"Dutch","pa":"Punjabi","pl":"Polish",
    "pt":"Portuguese","ro":"Romanian","ru":"Russian","sk":"Slovak",
    "sl":"Slovenian","sq":"Albanian","sr":"Serbian","sv":"Swedish",
    "sw":"Swahili","ta":"Tamil","te":"Telugu","th":"Thai","tl":"Filipino",
    "tr":"Turkish","uk":"Ukrainian","ur":"Urdu","uz":"Uzbek",
    "vi":"Vietnamese","zh":"Chinese","zh-TW":"Chinese (Traditional)"
  };

  function _langImg(code) {
    var base = code.split("-")[0].toLowerCase();
    var cc = _LANG_CC[code] || _LANG_CC[base];
    if (!cc || cc.length !== 2) return "";
    return '<img src="https://flagcdn.com/20x15/' + cc.toLowerCase() + '.png"' +
           ' width="20" height="15" alt=""' +
           ' style="border-radius:1px;vertical-align:middle;display:inline-block">';
  }

  function _langName(code) {
    var base = code.split("-")[0].toLowerCase();
    return _LANG_NAME[code] || _LANG_NAME[base] || code.toUpperCase();
  }

  // ---------------------------------------------------------------------------
  // _buildPickerInto(container) — factory that renders a complete language
  // picker into any given DOM element and returns a sync function(lang) that
  // updates the button label and selected-item highlight.  Called once per
  // mount point; all state (btn, drop, closeDrop) is scoped to the closure.
  // ---------------------------------------------------------------------------
  function _buildPickerInto(container) {
    // Inject widget CSS once per page.
    if (!document.getElementById("uvt-styles")) {
      var style = document.createElement("style");
      style.id = "uvt-styles";
      style.textContent =
        "#univtrans-lang-picker{position:relative;display:inline-block;font-family:inherit;margin-left:10px}" +
        "#univtrans-lang-picker-mobile{position:relative;display:inline-block;font-family:inherit}" +
        ".uvt-btn{display:flex;align-items:center;gap:5px;padding:5px 10px;" +
          "background:var(--color-base-background-1,#fff);" +
          "border:1px solid var(--color-base-outline-button-labels,rgba(0,0,0,.2));" +
          "border-radius:4px;cursor:pointer;font-size:13px;color:inherit;line-height:1.4}" +
        ".uvt-btn:hover{background:var(--color-base-background-2,#f5f5f5)}" +
        ".uvt-chev{display:inline-block;margin-left:2px;transition:transform .2s}" +
        ".uvt-btn[aria-expanded=true] .uvt-chev{transform:rotate(180deg)}" +
        ".uvt-drop{position:absolute;top:calc(100% + 4px);right:0;min-width:150px;" +
          "max-height:200px;overflow-y:auto;" +
          "background:var(--color-base-background-1,#fff);" +
          "border:1px solid var(--color-base-outline-button-labels,rgba(0,0,0,.2));" +
          "border-radius:4px;box-shadow:0 4px 16px rgba(0,0,0,.12);" +
          "list-style:none;margin:0;padding:4px 0;z-index:9999;display:none}" +
        ".uvt-drop.uvt-open{display:block}" +
        ".uvt-item{display:flex;align-items:center;gap:8px;padding:5px 12px 5px 10px;" +
          "cursor:pointer;font-size:13px;white-space:nowrap;color:inherit}" +
        ".uvt-item:hover,.uvt-item:focus{background:var(--color-base-background-2,#f5f5f5)}" +
        ".uvt-item.uvt-sel{font-weight:700}" +
        ".uvt-flag{display:inline-flex;align-items:center;line-height:1}" +
        ".uvt-code{text-transform:uppercase;letter-spacing:.04em}";
      (document.head || document.documentElement).appendChild(style);
    }

    // Include SOURCE_LANG as the first option so visitors can always revert.
    var allLangs = [SOURCE_LANG].concat(
      CONFIGURED_LANGS.filter(function(l) { return l !== SOURCE_LANG; })
    );

    var chevronSvg =
      '<svg class="uvt-chev" width="10" height="6" viewBox="0 0 10 6" fill="none" ' +
      'xmlns="http://www.w3.org/2000/svg"><path d="M1 1l4 4 4-4" stroke="currentColor" ' +
      'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var btn = document.createElement("button");
    btn.className = "uvt-btn";
    btn.setAttribute("type", "button");
    btn.setAttribute("aria-haspopup", "listbox");
    btn.setAttribute("aria-expanded", "false");

    var drop = document.createElement("ul");
    drop.className = "uvt-drop";
    drop.setAttribute("role", "listbox");

    for (var wi = 0; wi < allLangs.length; wi++) {
      (function(lang) {
        var li = document.createElement("li");
        li.className = "uvt-item";
        li.setAttribute("role", "option");
        li.setAttribute("data-uvt-lang", lang);
        li.innerHTML =
          '<span class="uvt-flag">' + _langImg(lang) + "</span>" +
          "<span>" + _langName(lang) + "</span>";
        li.addEventListener("click", function(e) {
          e.stopPropagation();
          closeDrop();
          applyLang(lang);
        });
        drop.appendChild(li);
      })(allLangs[wi]);
    }

    function openDrop() {
      drop.classList.add("uvt-open");
      btn.setAttribute("aria-expanded", "true");
    }
    function closeDrop() {
      drop.classList.remove("uvt-open");
      btn.setAttribute("aria-expanded", "false");
    }

    btn.addEventListener("click", function(e) {
      e.stopPropagation();
      drop.classList.contains("uvt-open") ? closeDrop() : openDrop();
    });
    document.addEventListener("click", closeDrop);
    document.addEventListener("keydown", function(e) {
      if (e.key === "Escape") closeDrop();
    });

    container.innerHTML = "";
    container.appendChild(btn);
    container.appendChild(drop);

    // Return a sync function that keeps this picker's display up to date.
    return function(lang) {
      btn.innerHTML =
        '<span class="uvt-flag">' + _langImg(lang) + "</span>" +
        '<span class="uvt-code">' + lang.toUpperCase() + "</span>" +
        chevronSvg;
      var items = drop.querySelectorAll(".uvt-item");
      for (var ii = 0; ii < items.length; ii++) {
        var itemLang = items[ii].getAttribute("data-uvt-lang");
        if (itemLang === lang) {
          items[ii].classList.add("uvt-sel");
        } else {
          items[ii].classList.remove("uvt-sel");
        }
      }
    };
  }

  // ---------------------------------------------------------------------------
  // buildLangWidget() — orchestrator.  Looks for both mount points
  // (#univtrans-lang-picker for desktop, #univtrans-lang-picker-mobile for the
  // hamburger drawer), builds a picker in each that exists, then sets
  // _widgetUpdate to a single function that keeps all pickers in sync.
  // ---------------------------------------------------------------------------
  function buildLangWidget() {
    var allLangs = [SOURCE_LANG].concat(
      CONFIGURED_LANGS.filter(function(l) { return l !== SOURCE_LANG; })
    );
    if (allLangs.length < 2) return;

    var updateFns = [];
    var c1 = document.getElementById("univtrans-lang-picker");
    if (c1) { var fn1 = _buildPickerInto(c1); if (fn1) updateFns.push(fn1); }
    var c2 = document.getElementById("univtrans-lang-picker-mobile");
    if (c2) { var fn2 = _buildPickerInto(c2); if (fn2) updateFns.push(fn2); }
    if (updateFns.length === 0) return;

    _widgetUpdate = function(lang) {
      for (var ui = 0; ui < updateFns.length; ui++) { updateFns[ui](lang); }
    };

    _widgetUpdate(currentLang || SOURCE_LANG);
  }

  function init() {
    // Geo-language suggestion: fire once per session, fully non-blocking.
    // The fetch runs in parallel with config+exclusions but is NOT awaited —
    // language resolution uses whatever GEO_LANG value is present when it runs.
    // A 700ms AbortController timeout prevents lingering requests from ever
    // influencing behavior after init completes.
    var geoKey = "st_geo_" + STORE_ID;
    var cachedGeoVal = storageTryGet("session", geoKey);
    if (cachedGeoVal !== null && cachedGeoVal !== "pending") {
      // Already resolved this session — restore from cache, no network call.
      GEO_LANG = cachedGeoVal === "" ? null : cachedGeoVal;
    } else if (cachedGeoVal !== "pending") {
      // Mark as in-flight so concurrent page loads don't fire a second request.
      storageTrySet("session", geoKey, "pending");
      try {
        var geoAbort = new AbortController();
        var geoTimer = setTimeout(function() { geoAbort.abort(); }, 700);
        fetch(API_BASE + "/api/stores/" + STORE_ID + "/geo-lang", { signal: geoAbort.signal })
          .then(function(r) { return r.json(); })
          .then(function(data) {
            clearTimeout(geoTimer);
            var suggested = (data && typeof data.suggestedLang === "string") ? data.suggestedLang : null;
            GEO_LANG = suggested;
            storageTrySet("session", geoKey, suggested || "");
          })
          .catch(function() {
            clearTimeout(geoTimer);
            storageTrySet("session", geoKey, "");
          });
      } catch(e) {
        storageTrySet("session", geoKey, "");
      }
    }

    Promise.all([
      fetch(API_BASE + "/api/stores/" + STORE_ID + "/config/public").then(function(r) { return r.json(); }),
      fetch(API_BASE + "/api/stores/" + STORE_ID + "/exclusions/public").then(function(r) { return r.json(); })
    ]).then(function(results) {
      var configData = results[0];
      var exclData = results[1];
      if (configData && Array.isArray(configData.languages)) CONFIGURED_LANGS = configData.languages;
      if (configData && typeof configData.sourceLang === "string") SOURCE_LANG = configData.sourceLang;
      if (exclData && Array.isArray(exclData.terms)) EXCLUSIONS = exclData.terms;

      // If the server reports a higher cache revision than the one baked into
      // this snippet, wipe all per-language localStorage caches.  This lets
      // the back-end invalidate corrupt or stale client-side caches (e.g.
      // entries produced by a now-fixed translation bug) without requiring
      // store owners to reinstall the snippet.
      if (configData && typeof configData.cacheRevision === "number" &&
          configData.cacheRevision > CACHE_REVISION) {
        CACHE_REVISION = configData.cacheRevision;
        cache = {};
        lsCacheLoaded = {};
        for (var li = 0; li < CONFIGURED_LANGS.length; li++) {
          storageTryRemove("local", lsCacheKey(CONFIGURED_LANGS[li]));
        }
      }

      // One-time browser language demand reporting (once per device per store).
      // Normalize navigator.languages to deduplicated base codes (e.g. ["fr-FR","fr","en"] → ["fr","en"]).
      // Set the localStorage gate AFTER any response (success or error) so the fetch only fires once.
      try {
        var blsKey = "st_bls_" + STORE_ID;
        if (!storageTryGet("local", blsKey)) {
          var rawNavLangs = (navigator.languages && navigator.languages.length)
            ? Array.prototype.slice.call(navigator.languages)
            : (navigator.language ? [navigator.language] : []);
          var seenBls = {};
          var normLangs = [];
          for (var bi = 0; bi < rawNavLangs.length && normLangs.length < 20; bi++) {
            var baseCode = rawNavLangs[bi].split("-")[0].toLowerCase();
            if (/^[a-z]{2,3}$/.test(baseCode) && !seenBls[baseCode]) {
              seenBls[baseCode] = true;
              normLangs.push(baseCode);
            }
          }
          if (normLangs.length > 0) {
            fetch(API_BASE + "/api/stores/" + STORE_ID + "/browser-langs/report", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ langs: normLangs })
            }).then(function() {
              storageTrySet("local", blsKey, "1");
            }).catch(function() {
              storageTrySet("local", blsKey, "1");
            });
          } else {
            // Nothing valid to report; gate it anyway so we never attempt again.
            storageTrySet("local", blsKey, "1");
          }
        }
      } catch(e) {}

      var urlLocale = detectUrlLocale();
      if (urlLocale) {
        // URL locale always takes priority — update saved preference to match.
        currentLang = urlLocale;
        storageTrySet("local", "st_lang", urlLocale);
        // Clear the anti-loop flag: redirect was successful (we landed on a locale URL).
        // This allows the next visit to a non-locale URL to redirect again.
        storageTryRemove("session", "st_redirected");
      } else {
        // Determine target locale: saved preference takes priority, browser locale as fallback,
        // then IP geo-language suggestion, then source language.
        var savedLang = storageTryGet("local", "st_lang");
        var targetLocale = (savedLang ? matchLang(savedLang) : null) || detectBrowserLocale() || (GEO_LANG ? matchLang(GEO_LANG) : null);
        if (targetLocale && targetLocale !== SOURCE_LANG) {
          if (!storageTryGet("session", "st_redirected")) {
            // First attempt this session — redirect to the locale URL.
            storageTrySet("session", "st_redirected", "1");
            var path = window.location.pathname;
            var newPath = "/" + targetLocale + (path === "/" ? "" : path);
            window.location.replace(newPath + window.location.search + window.location.hash);
            return;
          }
          // Guard is set: Shopify redirected back without the locale prefix.
          // Translate in place to avoid an infinite redirect loop.
          currentLang = targetLocale;
        } else {
          currentLang = SOURCE_LANG;
        }
      }

      if (currentLang !== SOURCE_LANG) {
        loadLsCache(currentLang);
        evictExclusionsFromCache(currentLang);
        translatePage(currentLang);
        observeDOMChanges();

        // Periodic re-scan fallback for timer- or scroll-triggered popups.
        // Some Shopify apps pre-render dialogs invisibly (CSS visibility/display
        // only) and reveal them after a delay or scroll event.  Because no DOM
        // node is inserted, the MutationObserver never fires.  Poll every 3 s
        // for the first 30 s after page load so those dialogs get translated.
        // NOTE: currentLang is read dynamically on every tick so that a
        // setLanguage() call or URL-locale change during the window is
        // respected; the timer will simply start translating into the new
        // language instead of fighting the previous selection.
        var _periodicCount = 0;
        var _PERIODIC_INTERVAL = 3000;
        var _PERIODIC_MAX = 20; // 20 × 3 s = 60 s total (extended for late-appearing popups)
        var _periodicTimer = setInterval(function() {
          _periodicCount++;
          if (_periodicCount >= _PERIODIC_MAX) {
            clearInterval(_periodicTimer);
          }
          // Nothing to do if the active language is the source language.
          if (currentLang === SOURCE_LANG) return;
          // Skip if a translation request is already in flight.
          if (inFlight[currentLang]) return;
          // Always call translatePage so that popup nodes revealed via CSS
          // (no childList mutation) and nodes that Klaviyo re-renders after
          // our applyTranslations pass (wiping _univtransOrig) are caught on
          // every tick.  translatePage itself is cheap when all texts are
          // already cached: it calls applyTranslations to stamp any fresh
          // nodes and returns without making an API call.
          translatePage(currentLang);
        }, _PERIODIC_INTERVAL);
      }
      // Render the language picker into <div id="univtrans-lang-picker"> if present.
      buildLangWidget();
    }).catch(function() {
      // Config fetch failed; skip translation silently
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();